export default __webpack_public_path__ + "static/media/priority_icon3.cfaf3e02.svg";